module.exports = __webpack_public_path__ + "img/cinema6.17b71e8e.jpg";